import { createContext } from "react";




// Create the context with a default value of undefined
export const DistributorNameContext = createContext();
